import React, { createContext, ReactNode, useContext, useState } from 'react'
import { useCallbackRef } from '@web/walter-ui-kit'
import { v4 as uuidv4 } from 'uuid'
import { OperationName } from '~constants/traces'

type TraceContextType = {
    generateOperationId: (operationName: OperationName) => void
    operationId?: string
    resetOperationId: () => void
}

const TraceContext = createContext<TraceContextType>({
    generateOperationId: () => null,
    resetOperationId: () => null,
})

export function TraceProvider({ children }: { children: ReactNode }) {
    const [operationId, setOperationId] = useState<string>()

    const generateOperationId = useCallbackRef((operationName: OperationName) => {
        const id = `${operationName}-${uuidv4().replace(/-/g, '')}`
        setOperationId(id)
    })

    const resetOperationId = useCallbackRef(() => setOperationId(undefined))

    return (
        <TraceContext.Provider value={{ operationId, generateOperationId, resetOperationId }}>
            {children}
        </TraceContext.Provider>
    )
}

export const useTraceContext = () => useContext(TraceContext)
